// extracted by mini-css-extract-plugin
export default {"mag_home_products_container":"products-tab_mag_home_products_container__sM2za"};